import { WizardLayout } from '../../components/wizard/WizardLayout';
import { WizardStep } from '../../components/wizard/WizardStep';
import { de } from '../../lib/i18n/de';
import { useDimensionForm } from '../../components/wizard/fields/useDimensionForm';
import {
  BooleanField,
  NumberField,
  TextareaField,
} from '../../components/wizard/fields/FormFields';
import { HEALTH_KEYS } from '../../lib/store/dimensionScoreInput';
import { DimensionLiveScore } from '../../components/wizard/fields/DimensionLiveScore';
import { SensitiveNote } from '../../components/wizard/fields/SensitiveNote';

const t = de.dimensionFields.health;

export function HealthStep() {
  const form = useDimensionForm('health');
  const hasContent = Object.values(form.fields).some((v) => v.trim().length > 0);

  return (
    <WizardLayout>
      <WizardStep
        stepId="health"
        canProceed={hasContent}
        lastSavedAt={form.lastSavedAt}
        saveState={form.lastSavedAt ? 'saved' : 'idle'}
        onProceed={form.markComplete}
      >
        <div className="space-y-8">
          <SensitiveNote>{t.sensitiveNote}</SensitiveNote>
          <NumberField
            id="health-resilience"
            label={t.resilienceLabel}
            hint={t.resilienceHint}
            min={1}
            max={10}
            value={form.get(HEALTH_KEYS.selfReportedResilienceScore)}
            onChange={(v) => {
              form.set(HEALTH_KEYS.selfReportedResilienceScore, v);
            }}
          />
          <NumberField
            id="health-hours"
            label={t.hoursPerWeekLabel}
            suffix={t.hoursPerWeekSuffix}
            min={0}
            value={form.get(HEALTH_KEYS.hoursWorkedPerWeek)}
            onChange={(v) => {
              form.set(HEALTH_KEYS.hoursWorkedPerWeek, v);
            }}
          />
          <BooleanField
            id="health-medical-cert"
            label={t.hasMedicalCertificationLabel}
            required
            value={form.get(HEALTH_KEYS.hasMedicalCertification)}
            onChange={(v) => {
              form.set(HEALTH_KEYS.hasMedicalCertification, v);
            }}
          />
          <BooleanField
            id="health-chronic"
            label={t.chronicConditionsLabel}
            required
            value={form.get(HEALTH_KEYS.chronicConditionsExist)}
            onChange={(v) => {
              form.set(HEALTH_KEYS.chronicConditionsExist, v);
            }}
          />
          <BooleanField
            id="health-affects-work"
            label={t.conditionsAffectWorkLabel}
            required
            value={form.get(HEALTH_KEYS.conditionsAffectWork)}
            onChange={(v) => {
              form.set(HEALTH_KEYS.conditionsAffectWork, v);
            }}
          />
          <TextareaField
            id="health-coping"
            label={t.copingLabel}
            hint={t.copingHint}
            helpKey="health.constraints"
            minLength={30}
            value={form.get(HEALTH_KEYS.copingStrategiesDescribed)}
            onChange={(v) => {
              form.set(HEALTH_KEYS.copingStrategiesDescribed, v);
            }}
          />
          <TextareaField
            id="health-past-crisis"
            label={t.pastCrisisLabel}
            hint={t.pastCrisisHint}
            minLength={30}
            value={form.get(HEALTH_KEYS.pastCrisisHandlingNotes)}
            onChange={(v) => {
              form.set(HEALTH_KEYS.pastCrisisHandlingNotes, v);
            }}
          />
          <TextareaField
            id="health-notes"
            label={de.dimensionFields.common.notesLabel}
            hint={de.dimensionFields.common.notesHint}
            placeholder={de.dimensionFields.common.notesPlaceholder}
            rows={3}
            value={form.get(HEALTH_KEYS.notes)}
            onChange={(v) => {
              form.set(HEALTH_KEYS.notes, v);
            }}
          />
          <DimensionLiveScore dimension="health" fields={form.fields} />
        </div>
      </WizardStep>
    </WizardLayout>
  );
}
